






import Vue from 'vue';

export default Vue.extend({
    name: 'footer-section',
    methods: {
        changeView() {
            this.$emit('changeView');
        },
    },
});
